import type * as Types from '../../../__generated__/bffGlobalTypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetWebhookUrlVariables = Types.Exact<{ [key: string]: never; }>;


export type GetWebhookUrl = {
  webhookUrl: string | null
};


export const GetWebhookUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWebhookUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webhookUrl"}}]}}]} as unknown as DocumentNode<GetWebhookUrl, GetWebhookUrlVariables>;